/*
  Boost AI Search & Filter custom JS (HELP-16873)

  Moved out of the Boost admin "Custom JS" box and into the theme so changes
  are tracked in git. The Boost admin box must stay EMPTY; edit this file and
  deploy through the normal pipeline instead.

  Content is unchanged from the admin box as of 2026-08-11. Note: the BugHerd
  comment below mentions a "#52 list-view Read more toggle" module; that
  module was never present in the box and is not in this file.

  Module 1: moves the Boost collection description below the product grid
  (adds .cmd-desc-moved, paired with rules in boost-customizations.css).
  Module 2: Quick View Shop Pay button + SKU sync (BugHerd #47/#51).
  Module 3: re-init Yotpo star ratings on Boost cards (new in HELP-16873,
  was never in the admin box; fixes a star race that also exists on live).
*/

/*********************** Custom JS for Boost AI Search & Discovery ************************/
(function () {
  function getDesc() {
    var all = Array.prototype.slice.call(
      document.querySelectorAll('.boost-sd__header-description')
    );
    var withText = all.filter(function (d) { return d.textContent.trim().length > 0; });
    return withText[0] || null; 
  }

  function moveDescription() {
    var desc = getDesc();
    var layout = document.querySelector('.boost-sd-layout--has-filter-vertical');
    if (!desc || !layout) return false;
    if (desc.contains(layout) || layout.contains(desc)) return false;

    if (layout.nextElementSibling === desc) {
      desc.classList.add('cmd-desc-moved');
      return true;
    }

    layout.parentNode.insertBefore(desc, layout.nextSibling);
    if (layout.nextElementSibling === desc) {
      desc.classList.add('cmd-desc-moved'); 
      return true;
    }
    return false;
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
        moveDescription();
      
    });
  }

  function retryFor(ms) {
    var stop = Date.now() + ms;
    (function tick() {
      if (moveDescription()) return; 
      if (Date.now() < stop) setTimeout(tick, 150);
    })();
  }

  function start() {
    retryFor(6000);
    var target = document.querySelector('.boost-sd-container') || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });

    window.addEventListener('popstate', function () { retryFor(4000); });

    var _push = history.pushState;
    history.pushState = function () {
      var r = _push.apply(this, arguments);
      retryFor(4000);
      return r;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* =============================================================
   BugHerd additions for the Boost custom JS.
   APPEND this to the end of your existing Boost custom JS (the file
   where the qv-go-to-my-media / qv-atc--added logic lives).
   Two independent modules: Shop Pay + SKU sync (#47/#51), and the
   list-view Read more toggle (#52).
   ============================================================= */

/* ---- #47 / #51 : Quick View Shop Pay button + SKU sync ---- */
(function () {
  var LOADER = 'https://cdn.shopify.com/shopifycloud/shop-js/modules/v2/loader.pay-button.esm.js';
  var MODAL_SEL = '#boost-sd__modal-quickview';
  var lastKey = null;
  var rafPending = false;

  function ensureLoader() {
    if (document.querySelector('script[data-qv-shop-pay-loader]')) return;
    var s = document.createElement('script');
    s.type = 'module';
    s.src = LOADER;
    s.setAttribute('data-qv-shop-pay-loader', '');
    document.head.appendChild(s);
  }

  function getVariants(modal) {
    try {
      var data = JSON.parse(modal.getAttribute('data-product'));
      return (data && data.variants) || [];
    } catch (e) { return []; }
  }

  function selectedVariant(modal, variants) {
    if (!variants.length) return null;
    if (variants.length === 1) return variants[0];
    var chosen = [];
    modal.querySelectorAll('.boost-sd__product-swatch').forEach(function (sw) {
      var checked = sw.querySelector('.boost-sd__radio-input:checked');
      var sel = sw.querySelector('.boost-sd__radio-label--selected');
      var val = checked ? checked.value : (sel ? sel.getAttribute('data-swatch-value') : null);
      if (val) chosen.push(String(val).trim());
    });
    if (!chosen.length) return variants[0];
    return variants.find(function (v) {
      var t = (v.title || '') + ' ' + ((v.merged_options || []).join(' '));
      return chosen.every(function (c) { return t.indexOf(c) !== -1; });
    }) || variants[0];
  }

  function sync(modal) {
    if (!modal) return;
    var v = selectedVariant(modal, getVariants(modal));
    if (!v) return;
    var spb = modal.querySelector('.qv-shop-pay-button');
    if (spb) spb.setAttribute('variants', String(v.id));
    var skuEl = modal.querySelector('.boost-sd__quick-view-sku');
    if (skuEl) {
      if (v.sku) { skuEl.textContent = 'SKU: ' + v.sku; skuEl.style.display = ''; }
      else { skuEl.style.display = 'none'; }
    }
  }

  function tick() {
    rafPending = false;
    var modal = document.querySelector(MODAL_SEL);
    if (!modal) return;
    var visible = modal.offsetParent !== null || getComputedStyle(modal).display !== 'none';
    if (!visible) return;
    var key = modal.getAttribute('data-product-id') || modal.getAttribute('data-product');
    if (key && key !== lastKey) {
      lastKey = key;
      ensureLoader();
      sync(modal);
    }
  }
  function schedule() { if (!rafPending) { rafPending = true; requestAnimationFrame(tick); } }

  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['data-product', 'data-product-id', 'class', 'style']
  });

  document.addEventListener('change', function (e) {
    var modal = e.target.closest && e.target.closest(MODAL_SEL);
    if (modal && e.target.closest('.boost-sd__product-swatch')) sync(modal);
  });
  document.addEventListener('click', function (e) {
    var lbl = e.target.closest && e.target.closest('.boost-sd__radio-label--in-quick-view');
    if (lbl) { var m = lbl.closest(MODAL_SEL); if (m) setTimeout(function () { sync(m); }, 60); }
  });

  schedule();
})();

/* ---- Module 3: Yotpo star ratings on Boost cards (HELP-16873) ----
   Boost renders each card with an empty legacy `.yotpo.bottomLine`
   placeholder, then calls Yotpo's initializer only if Yotpo has already
   loaded, while Yotpo's own load-time scan can run before the grid exists.
   On first paint neither side fires and the stars never render (reproduced
   on the live theme too). When un-initialized placeholders show up, call
   yotpoWidgetsContainer.initWidgets(): it converts each placeholder into a
   rendered .yotpo-widget-instance and is idempotent (repeat calls do not
   duplicate stars). Placeholders are marked before the call so a widget
   that fails to convert cannot retrigger an init loop. */
(function () {
  var ATTEMPTED = 'data-cmd-yotpo-attempted';

  function initPending() {
    var w = window.yotpoWidgetsContainer;
    if (!w || typeof w.initWidgets !== 'function') return false;
    var pending = document.querySelectorAll(
      '.boost-sd__product-item .yotpo.bottomLine:not([' + ATTEMPTED + '])'
    );
    if (!pending.length) return false;
    Array.prototype.forEach.call(pending, function (el) {
      el.setAttribute(ATTEMPTED, '');
    });
    w.initWidgets();
    return true;
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initPending();
    });
  }

  function retryFor(ms) {
    var stop = Date.now() + ms;
    (function tick() {
      if (initPending()) return;
      if (Date.now() < stop) setTimeout(tick, 250);
    })();
  }

  function start() {
    retryFor(15000);
    var target = document.querySelector('.boost-sd-container') || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
